import { render } from "./CircleChart.vue?vue&type=template&id=23d87b9a&scoped=true"
import script from "./CircleChart.vue?vue&type=script&lang=js"
export * from "./CircleChart.vue?vue&type=script&lang=js"

import "./CircleChart.vue?vue&type=style&index=0&id=23d87b9a&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23d87b9a"]])

export default __exports__